import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { Button, Form, Spinner } from "react-bootstrap";
import { useParams } from "react-router";
import { useRequestNewKeyMutation } from "../../app/features/apiSlice";
import { swalError, swalSuccess } from "../../helpers";

const RequestNewKey = () => {
  const { t } = useTranslation();
  const { lang } = useParams();
  const [formData, setFormData] = useState({
    message: "",
    language: lang,
  });

  const [requestNewKey, { isLoading }] = useRequestNewKeyMutation();
  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await requestNewKey(formData).unwrap();
      if (response?.error) {
        swalError(response, t("error.serverNotResponding"));
      } else {
        swalSuccess(response?.message);
      }
    } catch (err) {
      swalError(err, t("error.serverNotResponding"));
    }
  };

  return (
    <Form onSubmit={handleSubmit}>
      <Form.Group className="mb-3" controlId="message">
        <Form.Label>{t("message")}</Form.Label>
        <Form.Control
          as="textarea"
          rows={3}
          value={formData.message}
          onChange={(e) =>
            setFormData({ ...formData, message: e.target.value })
          }
        />
      </Form.Group>
      <Button variant="primary-outline" type="submit" disabled={isLoading}>
        {t("sendRequest")}
        {isLoading && <Spinner animation="border" size="sm" />}
      </Button>
    </Form>
  );
};

export default RequestNewKey;
